export const plurality = (count, string, generality = 's') => count > 1 ? `${string}${generality}` : string
